import React, { useRef, useState, useEffect } from 'react';
import AnimateHeightBase from './AnimateHeightBase';

const AnimateHeight = ({ children, ...props }) => {
  const [height, setHeight] = useState('auto');
  const contentDiv = useRef(null);

  useEffect(() => {
    const element = contentDiv.current;

    // Use the element's own window so notifications aren't throttled when
    // the element lives in a cross-window portal (e.g. popout panel).
    const RO = (element.ownerDocument?.defaultView ?? window).ResizeObserver;
    const resizeObserver = new RO(() => {
      setHeight(element.clientHeight);
    });

    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <AnimateHeightBase {...props} height={height} contentClassName="auto-content" contentRef={contentDiv} disableDisplayNone>
      {children}
    </AnimateHeightBase>
  );
};

export default AnimateHeight;
